import { fetch as fetchApi, isString } from "./api";

import { CloseLoop, CloseLoopCodec } from "../store/closeLoop/types";
import { flattenData, withDecoded } from "./index";

function mapToModel(data: object): CloseLoop {
  return withDecoded(CloseLoopCodec, data, decoded => ({
    ...decoded
  }));
}

export async function fetch(id: string | null | undefined, params?: {}): Promise<CloseLoop> {
  return fetchApi({
    nestedResourcePath: ["closeloop"],
    id,
    params
  })
    .then(response => {
      return isString(response.data) ? JSON.parse(response.data) : response.data;
    })
    .then(data => mapToModel(flattenData(data)));
}
